if (!customElements.get('cross-selling')) {
  class CrossSelling extends HTMLElement {
    constructor() {
      super();
      this.inputs = this.querySelectorAll('.cross-selling__input');
      this.cartDrawer = document.querySelector('cart-drawer');
      this.addToCartButtons = document.querySelectorAll('.product-form__submit');
      this.productConfigurator = document.querySelector('product-configurator');

      this.init();
    }

    init() {
      if (!this.productConfigurator) {
        this.setupAddToCartListeners();
      }
      this.setupDynamicActButtonText();
    }

    // Sets up dynamic text updates for 'Add to Cart' buttons when inputs change.
    setupDynamicActButtonText() {
      this.inputs.forEach(input => {
        input.addEventListener('change', () => this.updateButtonText(input.checked));
      });
    }

    // Update button text based on whether the input is checked or not
    updateButtonText(isChecked) {
      const newText = isChecked ? this.dataset.new : this.dataset.old;
      this.setButtonText(newText);
    }

    // Set the text content for all Add to Cart buttons
    setButtonText(text) {
      this.addToCartButtons.forEach(button => {
        button.firstElementChild.textContent = text;
      });
    }


    // Set up listeners for add-to-cart buttons
    setupAddToCartListeners() {
      this.addToCartButtons.forEach(button => {
        button.addEventListener('click', async (event) => {
          event.preventDefault();
          this.showLoadingState(button);

          const selectedItems = this.getSelectedProducts();
          let productId = document.querySelector('.product-variant-id').value
          this.addMainProduct(selectedItems, productId);

          await this.addToCart(selectedItems);
          this.hideLoadingState(button);
        });
      });
    }

    // Shows the loading state on the button
    showLoadingState(button) {
      button.classList.add('loading');
      button.querySelector('.loading-overlay__spinner').classList.remove('hidden');
    }

    // Hides the loading state on the button
    hideLoadingState(button) {
      button.classList.remove('loading');
      button.querySelector('.loading-overlay__spinner').classList.add('hidden');
    }

    // Adds the main product to the selected items
    addMainProduct(selectedItems, productId) {
      selectedItems.push({ id: productId, quantity: 1 });
    }

    // Get selected products from inputs
    getSelectedProducts() {
      return [...this.inputs]
        .filter(input => input.checked)
        .map(input => ({ id: input.dataset.productId, quantity: 1 }));
    }


    // Send an async request to add selected items to the cart
    async addToCart(items) {
      const formData = { items };
      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(formData),
        });

        const data = await response.json();
        await this.updateCartDrawer();
        await this.cartDrawer.open();
        console.log(data);
      } catch (error) {
        console.error('Error adding to cart:', error);
      }
    }

    // Update the cart drawer content
    async updateCartDrawer() {
      const newHTML = await this.fetchSection();
      const updatedCart = new DOMParser().parseFromString(newHTML, 'text/html').querySelector('.cart-drawer .drawer__inner');

      const currentContent = document.querySelector('.drawer__inner');
      if (currentContent.innerHTML !== updatedCart.innerHTML) {
        currentContent.innerHTML = updatedCart.innerHTML;
        this.cartDrawer.classList.remove('is-empty');
      }
    }

    // Fetch the updated cart drawer section
    async fetchSection() {
      const response = await fetch(window.Shopify.routes.root + '?section_id=cart-drawer');
      return response.text();
    }
  }

  customElements.define('cross-selling', CrossSelling);
}
